// src/lookback.ts
import { removeStartEndChars } from "@llm-ui/shared";

// src/options.ts
var defaultOptions = {
  startChar: "\u2985",
  endChar: "\u2986",
  delimiter: ",",
  allIndexesVisible: true,
  visibleIndexes: []
};
var getOptions = (userOptions) => {
  const result = { ...defaultOptions, ...userOptions };
  const { type, allIndexesVisible, visibleIndexes } = result;
  if (!type) {
    throw new Error("type option is required");
  }
  if (allIndexesVisible && visibleIndexes.length > 0) {
    throw new Error(
      "visibleIndexes should be [] when allIndexesVisible is true"
    );
  }
  return result;
};

// src/parseCsv.ts
var parseCsv = (csv, options) => {
  const { delimiter } = getOptions(options);
  return csv.split(delimiter).filter((item) => item !== "");
};

// src/lookback.ts
var csvBlockLookBack = (options) => {
  const completeOptions = getOptions(options);
  const {
    allIndexesVisible,
    visibleIndexes: visibleIndexesOption,
    delimiter
  } = completeOptions;
  return ({ output, isComplete, visibleTextLengthTarget }) => {
    const array = parseCsv(
      removeStartEndChars(output, completeOptions),
      completeOptions
    );
    const visibleIndexes = allIndexesVisible ? array.map((_, i) => i).slice(1) : visibleIndexesOption;
    let charsRemaining = visibleTextLengthTarget;
    const outputArray = array.reduce((acc, item, index) => {
      if (!visibleIndexes.includes(index)) {
        return [...acc, item];
      }
      const toKeep = Math.max(Math.min(charsRemaining, item.length), 0);
      charsRemaining -= toKeep;
      return [...acc, item.slice(0, toKeep)];
    }, []);
    const visibleArray = outputArray.filter(
      (_, index) => visibleIndexes.includes(index)
    );
    return {
      output: outputArray.join(delimiter),
      visibleText: visibleArray.length === 0 ? isComplete ? " " : "" : visibleArray.join("")
    };
  };
};

// src/matchers.ts
import { regexMatcher } from "@llm-ui/shared";
var findCompleteCsvBlock = (options) => {
  const { type, startChar, endChar, delimiter } = getOptions(options);
  const regex = new RegExp(
    `${startChar}${type}${delimiter}([\\s\\S]*?)${endChar}`
  );
  return regexMatcher(regex);
};
var findPartialCsvBlock = (options) => {
  const { type, startChar, delimiter } = getOptions(options);
  const regex = new RegExp(`${startChar}${type}${delimiter}([\\s\\S]*)`);
  return regexMatcher(regex);
};

// src/block.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var csvBlock = (options) => {
  return {
    findCompleteMatch: findCompleteCsvBlock(options),
    findPartialMatch: findPartialCsvBlock(options),
    lookBack: csvBlockLookBack(options),
    component: ({ blockMatch }) => /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("a", { href: "https://llm-ui.com/docs/blocks/csv", children: "Docs to setup your own component" }),
      /* @__PURE__ */ jsx("pre", { children: blockMatch.output })
    ] })
  };
};

// src/csvBlockExample.ts
var csvBlockExample = (example, options) => {
  const { startChar, endChar, delimiter, type } = getOptions(options);
  return `${startChar}${[type, ...example].join(delimiter)}${endChar}`;
};

// src/csvBlockPrompt.ts
var csvBlockPrompt = ({
  name,
  examples,
  options
}) => {
  const { startChar, endChar, delimiter, type } = getOptions(options);
  const examplePrompts = examples.map(
    (example) => csvBlockExample(example, options)
  );
  return `You can respond with a ${name} component using the following ${delimiter} delimited syntax: ${startChar}${type}${delimiter}${endChar}

Examples: 
${examplePrompts.join(`
`)}`;
};
export {
  csvBlock,
  csvBlockExample,
  csvBlockLookBack,
  csvBlockPrompt,
  findCompleteCsvBlock,
  findPartialCsvBlock,
  parseCsv
};
//# sourceMappingURL=index.js.map